/**
 * Returns an intersection of all provided arrays
 * @param arrays
 */
export default function getUnion<T>(arrays: T[][]): T[] {
	return [...new Set([...arrays.flat()])]
}
